export const applyPhoneMask = (value?: string | null): string => {
	if (!value) return '';
	const rawDigits = value.replace(/\D/g, '');
	const digits = (rawDigits.length > 11 && rawDigits.startsWith('55') ? rawDigits.slice(2) : rawDigits).slice(0, 11);
	if (digits.length === 0) return '';
	if (digits.length <= 2) return digits.replace(/(\d{0,2})/, '($1');
	if (digits.length <= 7) return digits.replace(/(\d{2})(\d{0,5})/, '($1)$2');
	return digits.replace(/(\d{2})(\d{5})(\d{0,4})/, '($1)$2-$3');
};

export const formatPhoneForApi = (value?: string | null): string => {
	if (!value) return '';
	const rawDigits = value.replace(/\D/g, '');
	const digits = (rawDigits.length > 11 && rawDigits.startsWith('55') ? rawDigits.slice(2) : rawDigits).slice(0, 11);
	return digits ? `55${digits}` : '';
};

export const applyCpfMask = (value: string): string => {
	const digits = value.replace(/\D/g, '').slice(0, 11);
	if (digits.length <= 3) return digits;
	if (digits.length <= 6) return digits.replace(/(\d{3})(\d{0,3})/, '$1.$2');
	if (digits.length <= 9) return digits.replace(/(\d{3})(\d{3})(\d{0,3})/, '$1.$2.$3');
	return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{0,2})/, '$1.$2.$3-$4');
};

export const applyCnpjMask = (value: string): string => {
	const digits = value.replace(/\D/g, '').slice(0, 14);
	if (digits.length <= 2) return digits;
	if (digits.length <= 5) return digits.replace(/(\d{2})(\d{0,3})/, '$1.$2');
	if (digits.length <= 8) return digits.replace(/(\d{2})(\d{3})(\d{0,3})/, '$1.$2.$3');
	if (digits.length <= 12) return digits.replace(/(\d{2})(\d{3})(\d{3})(\d{0,4})/, '$1.$2.$3/$4');
	return digits.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{0,2})/, '$1.$2.$3/$4-$5');
};

export const applyDocumentMask = (value: string): string => {
	const digits = value.replace(/\D/g, '').slice(0, 14);
	return digits.length > 11 ? applyCnpjMask(digits) : applyCpfMask(digits);
};

export const getDocumentType = (value?: string | null): 'cpf' | 'cnpj' | undefined => {
	const digits = (value ?? '').replace(/\D/g, '');
	if (digits.length === 11) return 'cpf';
	if (digits.length === 14) return 'cnpj';
	return undefined;
};
